export default {"src":"/newStatic/_next/static/media/fact-1.2d902004.svg","height":37,"width":37};